import {
  Box,
  TextField,
  Card,
  CardContent,
  Typography,
  Button,
  CardHeader,
  Divider,
  Grid,
  InputLabel,
  Select,
  MenuItem,
  Checkbox,
  ListItemText,
  Container
} from '@mui/material';

import { useNavigate, useParams } from 'react-router-dom';
import { List, ListItem, CircularProgress } from '@mui/material';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useEffect, useState, useRef } from 'react';
import AWS from 'aws-sdk';
import axios from 'axios';
import { toast } from 'react-toastify';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

// AWS S3 Configuration
AWS.config.update({
  accessKeyId: 'AKIAWX5OXDFHSE3ZUKMI',
  secretAccessKey: '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',
  region: 'ap-south-1'
});

const EditCondolanceMessage = () => {
  const today = new Date().toISOString().split('T')[0];

  const { id } = useParams(); // Get the ID from the URL
  const [image, setImage] = useState(null);
  const [img, setImg] = useState<string | null>(null);
  const [users, setUsers] = useState([]);
  const [initialValuesLoaded, setInitialValuesLoaded] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedUser, setSelectedUser] = useState(null);
  const [loading, setLoading] = useState(false); // For loading state
  const [showDropdown, setShowDropdown] = useState(false);
  const inputRef = useRef(null);
  const [imageErr, setImageErr] = useState(false);

  const navigate = useNavigate();

  const s3 = new AWS.S3();

  // Handle Image File Upload

  async function handleImageFile(e) {
    setImageErr(false);
    const file = e.target.files[0];
    const folderPath = 'community1/';
    if (file) {
      setImage(file.name);
      const params = {
        Bucket: 'chaturvedi-v2',
        Key: `${folderPath}${Date.now()}_${file.name}`,
        // Key: `${Date.now()}_${file.name}`,
        Body: file,
        ACL: 'public-read', // Ensure this is set according to your permissions
        ContentType: file.type // Set the content type
      };

      try {
        console.log('Uploading to S3...', params);
        const { Location } = await s3.upload(params).promise();
        setImg(Location);
        console.log('Upload successful:', Location);
      } catch (error) {
        console.error('Upload failed:', error);
        toast.error(`Upload failed: ${error.message}`, {
          position: 'bottom-right'
        });
      }
    } else {
      setImageErr(true);
    }
  }

  // Handle clicks outside the dropdown
  useEffect(() => {
    const handleClickOutside = (event) => {
      // Check if the clicked element is outside both the dropdown and the input field
      if (inputRef.current && !inputRef.current.contains(event.target)) {
        console.log('ddddddd');
        setShowDropdown(false); // Hide the dropdown
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  useEffect(() => {
    fetchCondolanceData(); // Fetch data to pre-fill the form
    // handleNotificationData(); // Fetch users
  }, [id]);

  const fetchCondolanceData = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/condolance/getCondolance/${id}`
      );
      const { name, message, image, user, description,status, expirydate } = response.data;
      console.log(message, 'mmmmmmmmmm');

      const userid = response.data.user._id;

      // Format expirydate to 'YYYY-MM-DD' format for date input
      const formattedExpiryDate = expirydate
        ? new Date(expirydate).toISOString().split('T')[0]
        : '';

      // Ensure that `user` is always an array
      const userArray = Array.isArray(user) ? user : [user];
      const newname = user.name;

      formik.setValues({
        name,
        message,
        description,
        expirydate: formattedExpiryDate, // Set formatted expiry date
        status: status.toString(),
        user: userid,
        image
      });

      setSelectedUser(`${user.name}/${user.area}/${user.familyId}`);
      setImg(image); // Set image if already uploaded
    } catch (error) {
      console.error('Error fetching condolance data:', error);
    } finally {
      setInitialValuesLoaded(true); // Ensure loading state is set to true after fetching
    }
  };

  const handleupdate = async (e) => {
    const keyword = e.target.value;
    console.log(e.key, 'eddddddddddddddddd');

    setSelectedUser(keyword); // Update the local state for the dropdown
    formik.setFieldValue('user', keyword);

    if (e.key == 'Backspace' || e.key === 'Delete') {
      setSelectedUser(null);
    }

    if (keyword.length > 0) {
      setLoading(true); // Set loading state
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL
          }/members/searchuser?name=${encodeURIComponent(keyword)}`
        );
        console.log(response, 'lllllllffffffff');

        setUsers(response.data); // Store users from API
        setShowDropdown(true); // Show dropdown
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false); // Stop loading
      }
    } else {
      setShowDropdown(false); // Hide dropdown when input is cleared
      setUsers([]); // Clear users
    }
  };
  const handleSelectUser = (user) => {
    setSelectedUser(user.name);
    formik.setFieldValue('user', user._id); // Set the selected user in the input
    setShowDropdown(false); // Hide dropdown after selecting a user
  };

  const formik = useFormik({
    initialValues: {
      name: '',
      message: '',
      description: '',
      expirydate: '',
      image: '',
      status: '',
      user: ''
    },
    validationSchema: Yup.object({
      name: Yup.string().required('Please select a name'),
      message: Yup.string().required('Please select a message'),
      description: Yup.string().required('Please select a message'),
      user: Yup.string().required('Please select a User'),
      status: Yup.string().required('Please select a Status'),
      expirydate: Yup.date().required('Please select a Expirydate')
    }),
    onSubmit: async (values) => {
      const data = {
        name: values.name,
        message: values.message,
        description: values.description,
        status: values.status,
        user: values.user,
        expirydate: values.expirydate,

        image: img
      };

      try {
        await axios.put(
          `${process.env.REACT_APP_API_BASE_URL}/condolance/updateCondolance/${id}`,
          JSON.stringify(data),
          {
            headers: {
              'Content-Type': 'application/json'
            }
          }
        );
        toast.success('Condolance message updated successfully!', {
          position: 'bottom-right'
        });
        navigate('/condolance-messages/list');
      } catch (error) {
        toast.error(error?.response?.data?.error || 'User Already Exists', {
          position: 'bottom-right'
        });
      }
    },
    enableReinitialize: true // Allow Formik to reinitialize with the fetched values
  });

  if (!initialValuesLoaded) {
    return <div>Loading...</div>; // Add a loader while data is being fetched
  }

  return (
    <Container maxWidth="lg">
      <Card>
        <form onSubmit={formik.handleSubmit} style={{ margin: 30 }}>
          <Grid item xs={12}>
            <Card>
              <CardHeader
                title="Edit Condolance Message"
                titleTypographyProps={{
                  style: {
                    margin: 0,
                    width: '100%',
                    color: '#000',
                    fontWeight: 700,
                    fontSize: '25px',
                    marginBottom: '30px'
                  }
                }}
              />

              <CardContent>
                <Box component="form" noValidate autoComplete="off">
                  <div
                    style={{
                      display: 'flex',
                      // justifyContent: 'space-between',
                      flexWrap: 'wrap'
                    }}
                  >
                    <div style={{ margin: 9, width: '48%' }}>
                      <TextField
                        fullWidth
                        label="Name"
                        name="name"
                        value={formik.values.name}
                        onChange={(e) => {
                          const { value } = e.target;
                          const formattedValue =
                            value.charAt(0).toUpperCase() + value.slice(1);
                          formik.setFieldValue('name', formattedValue);
                        }}
                        onBlur={formik.handleBlur}
                        error={
                          formik.touched.name && Boolean(formik.errors.name)
                        }
                        helperText={formik.touched.name && formik.errors.name}
                      />
                    </div>
                    <div
                      style={{ margin: 9, width: '48%', position: 'relative' }}
                    >
                      <TextField
                        fullWidth
                        label="User"
                        name="user"
                        value={selectedUser}
                        onKeyDown={(e) => handleupdate(e)} // Use modified handleupdate
                        onBlur={formik.handleBlur}
                        onChange={(e) => handleupdate(e)}
                        error={
                          formik.touched.user && Boolean(formik.errors.user)
                        }
                        helperText={formik.touched.user && formik.errors.user}
                        autoComplete="off"
                        disabled
                      />

                      {/* Loading indicator */}
                      {loading && (
                        <CircularProgress
                          size={24}
                          style={{ position: 'absolute', right: 10, top: 35 }}
                        />
                      )}

                      {/* Dropdown list */}
                      {showDropdown && users.length > 0 && (
                        <List
                          ref={inputRef}
                          style={{
                            border: '1px solid #ccc',
                            maxHeight: 200,
                            overflowY: 'auto',
                            position: 'absolute',
                            width: '100%',
                            backgroundColor: '#fff',
                            zIndex: 1000
                          }}
                        >
                          {users.map((user) => (
                            <ListItem
                              button
                              key={user._id}
                              onClick={() => handleSelectUser(user)}
                            >
                              <ListItemText primary={user.name} />
                            </ListItem>
                          ))}
                        </List>
                      )}
                    </div>
                  </div>
                  <div style={{ margin: 9, width: '97.5%' }}>
                  <InputLabel shrink htmlFor="description" style={{ marginBottom: 1,marginTop:4}}>
                      Detailed Description
                      </InputLabel>
                    <ReactQuill
                      value={formik.values.message}
                      onChange={(message) => {
                        formik.setFieldValue('message', message); // Update Formik state
                      }}
                      onBlur={() => formik.setFieldTouched('message', true)}
                      modules={{
                        toolbar: [
                          [{ header: [1, 2, false] }],
                          ['bold', 'italic', 'underline'],
                          [{ color: [] }], // color picker added here
                          ['link', 'image'],
                          ['clean']
                        ]
                      }}
                      formats={[
                        'header',
                        'bold',
                        'italic',
                        'underline',
                        'color', // add color format
                        'link',
                        'image'
                      ]}
                    />
                    {formik.touched.message && formik.errors.message && (
                      <div style={{ color: 'red', marginTop: '5px' }}>
                        {formik.errors.message}
                      </div>
                    )}
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      // justifyContent: 'space-between',
                      flexWrap: 'wrap'
                    }}
                  >
                    <div style={{ margin: 9, width: '48%' }}>
                      <InputLabel
                        shrink
                        htmlFor="Status"
                        style={{ marginBottom: 4 }}
                      >
                        Status
                      </InputLabel>

                      <Select
                        fullWidth
                        label="Status"
                        name="status"
                        value={formik.values.status}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={
                          formik.touched.status && Boolean(formik.errors.status)
                        }
                      >
                        <MenuItem value="">
                          <em>Select Status</em>
                        </MenuItem>
                        <MenuItem value="true">True</MenuItem>
                        <MenuItem value="false">False</MenuItem>
                      </Select>
                      {formik.touched.status && formik.errors.status && (
                        <div
                          style={{ color: 'red', fontSize: 12, marginTop: 5 }}
                        >
                          {formik.errors.status}
                        </div>
                      )}
                    </div>
                    <div style={{ margin: 9, width: '48%' }}>
                      <InputLabel
                        shrink
                        htmlFor="expirydate"
                        style={{ marginBottom: 4 }}
                      >
                        Expiry Date
                      </InputLabel>
                      <TextField
                        fullWidth
                        // label="Expiry Date"
                        type="date"
                        name="expirydate"
                        inputProps={{
                          max: today
                        }}
                        value={formik.values.expirydate}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={
                          formik.touched.expirydate &&
                          Boolean(formik.errors.expirydate)
                        }
                        helperText={
                          formik.touched.expirydate && formik.errors.expirydate
                        }
                      />

                      <InputLabel shrink htmlFor="description" style={{ marginBottom: 4 }}>
                      Push Notification Description
                      </InputLabel>
                      <TextField
                        fullWidth
                        type="text"
                        name="description"
                        multiline={true} // Enables multiline input
                        rows={4} // Adjusts the height of the text area
                        value={formik.values.description}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={formik.touched.description && Boolean(formik.errors.description)}
                        helperText={formik.touched.description && formik.errors.description}
                      />

                    </div>
                  </div>

                  {/* Image Upload Field */}
                  <div style={{ margin: 9, width: '32%' }}>
                    <div style={{ margin: 9 }}>
                      <input type="file" onChange={handleImageFile} />
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        {/* <AttachFileIcon /> */}
                        {/* <label>Choose an Image</label> */}
                      </div>
                      {img && (
                        <img
                          src={img}
                          alt="Uploaded"
                          style={{ maxWidth: '170px' }}
                        />
                      )}
                    </div>
                  </div>
                </Box>
              </CardContent>
              <div
                style={{
                  display: 'flex',
                  // justifyContent: 'flex-end',
                  margin: '30px'
                }}
              >
                <Button variant="contained" color="primary" type="submit">
                  Submit
                </Button>
              </div>
            </Card>
          </Grid>
        </form>
      </Card>
    </Container>
  );
};

export default EditCondolanceMessage;
